import { TurboModuleRegistry } from 'react-native';
export default TurboModuleRegistry.getEnforcing('RNExitApp');
